<script>
  import { link, activeClass, t } from "../../../core";
  import type { ISubMenuItem } from "./Construction.svelte";

  export let items: ISubMenuItem[];
</script>

<section class="left-nav g-centered">
  <div class="left-nav__content">
    <div class="left-nav__title">
      {t("ConstructionProcess.General.Title")}
    </div>

    {#each items as item}
      <a
        use:link
        use:activeClass={"active"}
        href={item.url}
        class="left-nav__item"
      >
        <span class="link">{item.title}</span>
      </a>
    {/each}
  </div>
</section>

<style lang="scss">
  .left-nav {
    margin-bottom: 40px;

    &__content {
      background-color: #ebebeb;
      padding-bottom: 40px;
    }

    &__title {
      @include h2;
      padding: 30px 30px 25px;
    }

    &__item {
      display: block;
      padding: 10px 30px;
    }
  }

  :global(.left-nav__item.active) {
    background: $text-reverse-color;
    box-shadow: inset 3px 0 0 0 $contrast-color;

    .link {
      font-weight: 900;
      color: $text-color;
      text-decoration: none;
    }
  }
</style>
